import { Component, inject } from '@angular/core';
import { IgxGridModule } from '@infragistics/igniteui-angular';
import { ParkerStateService } from 'src/app/core/services/state/parker-state.service';

@Component({
  selector: 'app-test-grid',
  standalone: true,
  imports: [IgxGridModule],
  templateUrl: './test-grid.component.html',
  styleUrl: './test-grid.component.scss',
})
export class TestGridComponent {
  //Services
  parkerStateService = inject(ParkerStateService);
}
